import { createContext, useContext } from "react";
import type { Language, ThemeMode } from "./types";

export interface UiStateContextValue {
  lang: Language;
  themeMode: ThemeMode;
  setLang: (next: Language) => void;
  toggleLang: () => void;
  toggleTheme: (nextDark: boolean) => void;
  authed: boolean;
  logout: () => void;
  /** 仅清除 token 与登录态，不跳转（用于 401 后由弹层引导去登录） */
  clearAuthSession: () => void;
}

export const UiStateContext = createContext<UiStateContextValue | null>(null);

export function useUiState() {
  const context = useContext(UiStateContext);
  if (!context) {
    throw new Error("useUiState must be used within UiStateContext.Provider");
  }
  return context;
}
